import React, { useState, useEffect } from 'react';
import Footerdiv from "../layout/footer.js";
import Headerdiv from "../layout/header.js";
import {
    Layout, Breadcrumb, Spin, Form, Input, Button, Select,
    Row, Col, Card
} from 'antd';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { MAINAPIURL, APPBACKGROUND_COLOR } from '../appsettings.js';
import { AlertError, AlertSuccess } from '../usableclasses.js';

const { Content } = Layout;
const { Option } = Select;

const MLMUserEdit = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const USERID = localStorage.getItem("USERID");

    const [mlmUser, setMlmUser] = useState(null);
    const [banks, setBanks] = useState([]);
    const [branches, setBranches] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchBranches = async (bankId) => {
        try {
            const res = await axios.get(`${ApiURL}/master/banksbranch/dropdown/${bankId}`, {
                headers: { SystemAccessToken: TOKEN }
            });
            setBranches(res.data || []);
        } catch (err) {
            console.error(err);
            setBranches([]);
        }
    };

    const handleBankChange = async (value) => {
        form.setFieldsValue({ branchId: undefined });
        await fetchBranches(value);
    };

    const fetchDistricts = async () => {
        try {
            const res = await axios.get(`${ApiURL}/mlm/user/dropdown/districtlist`, {
                headers: { SystemAccessToken: TOKEN }
            });
            setDistricts(res.data || []);
        } catch (err) {
            console.error(err);
        }
    };

    const fetchMlmUserDetails = async () => {
        try {
            setLoading(true);
            const res = await axios.post(`${ApiURL}/erp/mlmuser/getdetail`, { userId: id }, {
                headers: { SystemAccessToken: TOKEN }
            });
            if (res.data) {
                setMlmUser(res.data);
                form.setFieldsValue({
                    firstName: res.data.mlM_FIRSTNAME,
                    lastName: res.data.mlM_SECONDNAME,
                    mobileNo: res.data.mlM_USERMOBILE,
                    nicNo: res.data.mlM_REGDOCNO,
                    email: res.data.mlM_USEREMAIL,
                    bankId: res.data.mlM_BANKID,
                    branchId: res.data.mlM_BANKBRANCHID,
                    accountNo: res.data.mlM_BANKACCNO,
                    accountName: res.data.mlM_BANKACCNAME,
                    billingAddress1: res.data.mlM_BILLADDR1,
                    billingAddress2: res.data.mlM_BILLADDR2,
                    billingCity: res.data.mlM_BILLCITY,
                    billingDistrict: res.data.mlM_BILLDISTRICT,
                    shippingAddress1: res.data.mlM_SHIPADDR1,
                    shippingAddress2: res.data.mlM_SHIPADDR2,
                    shippingCity: res.data.mlM_SHIPCITY,
                    shippingDistrict: res.data.mlM_SHIPDISTRICT,
                });

                if (res.data.mlM_BANKID) {
                    await fetchBranches(res.data.mlM_BANKID);
                }
            }
        } catch (err) {
            console.error(err);
            AlertError("Error fetching MLM user data.");
        } finally {
            setLoading(false);
        }
    };

    const fetchBanks = async () => {
        try {
            const res = await axios.get(`${ApiURL}/master/banks/dropdown`, {
                headers: { SystemAccessToken: TOKEN }
            });
            setBanks(res.data || []);
        } catch (err) {
            console.error(err);
        }
    };

    const onFinish = async (values) => {
        try {
            setLoading(true);
            const payload = {
                mlmUserId: id,
                firstName: values.firstName,
                secondName: values.lastName,
                emailAddress: values.email,
                nicNo: mlmUser?.mlM_REGDOCNO ?? "",
                bankId: values.bankId,
                bankBranchId: values.branchId,
                accountName: values.accountName,
                accountNumber: values.accountNo,
                billingAddress1: values.billingAddress1,
                billingAddress2: values.billingAddress2,
                billingCity: values.billingCity,
                billingDistrict: values.billingDistrict,
                shippingAddress1: values.shippingAddress1,
                shippingAddress2: values.shippingAddress2,
                shippingCity: values.shippingCity,
                shippingDistrict: values.shippingDistrict,
                updatedBy: USERID,
            };

            await axios.post(`${ApiURL}/erp/mlmuser/updateuserinformation`, payload, {
                headers: { SystemAccessToken: TOKEN }
            });

            AlertSuccess("User details updated successfully");
            fetchMlmUserDetails();
        } catch (err) {
            console.error(err);
            AlertError("Failed to update user information.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMlmUserDetails();
        fetchBanks();
        fetchDistricts();
    }, [id]);

    return (
        <Spin spinning={loading} tip="Loading user details...">
            <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
                <Headerdiv />
                <Content style={{ padding: '10px' }}>
                    <Breadcrumb style={{ margin: "16px 0" }}>
                        <Breadcrumb.Item><Link to="/mlm/userlist">MLM User</Link></Breadcrumb.Item>
                        <Breadcrumb.Item><Link to={`/mlm/userview/${id}`}>View</Link></Breadcrumb.Item>
                        <Breadcrumb.Item>Edit User</Breadcrumb.Item>
                    </Breadcrumb>

                    <Form form={form} layout="vertical" onFinish={onFinish}>
                        <Card title="Edit User Information" style={{ marginBottom: 16 }}>
                            <Row gutter={16}>
                                <Col xs={24} sm={12} md={8}>
                                    <Form.Item label="Consult ID">
                                        <Input value={mlmUser?.mlM_CONSULTID || "-"} disabled />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8}>
                                    <Form.Item name="firstName" label="First Name" rules={[{ required: true, message: "First name is required" }]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8}>
                                    <Form.Item name="lastName" label="Last Name" rules={[{ required: true, message: "Last name is required" }]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8}>
                                    <Form.Item name="nicNo" label="NIC No" rules={[{ required: true, message
                                        : "NIC number is required" }]}>
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8}>
                                    <Form.Item name="mobileNo" label="Mobile No">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={8}>
                                    <Form.Item name="email" label="Email Address" rules={[
                                        { required: true, message: "Email is required" },
                                        { type: 'email', message: "Enter a valid email" }
                                    ]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Card>

                        <Card title="Edit Bank Information" style={{ marginBottom: 16 }}>
                            <Row gutter={16}>
                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item name="bankId" label="Bank Name">
                                        <Select placeholder="Select Bank" onChange={handleBankChange} allowClear>
                                            {banks.map(opt => (
                                                <Option key={opt.id} value={opt.id}>{opt.id} - {opt.label}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item name="branchId" label="Branch Name">
                                        <Select placeholder="Select Branch" allowClear disabled={!form.getFieldValue('bankId')}>
                                            {branches.map(opt => (
                                                <Option key={opt.id} value={opt.id}>{opt.label}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item name="accountNo" label="Account No">
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item name="accountName" label="Account Name" >
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Card>

                        <Card title="Edit Billing Information" style={{ marginBottom: 16 }}>
                            <Row gutter={16}>
                                <Col xs={24} sm={12} md={6}><Form.Item name="billingAddress1" label="Billing Address 1" rules={[{ required: true, message: "Billing address is required" }]}><Input /></Form.Item></Col>
                                <Col xs={24} sm={12} md={6}><Form.Item name="billingAddress2" label="Billing Address 2" rules={[{ required: true, message: "Billing address is required" }]}><Input /></Form.Item></Col>
                                <Col xs={24} sm={12} md={6}><Form.Item name="billingCity" label="Billing City" rules={[{ required: true, message: "Billing city is required"  }]}><Input /></Form.Item></Col>
                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item name="billingDistrict" label="Billing District" rules={[{ required: true }]}>
                                        <Select placeholder="Select District" allowClear>
                                            {districts.map(opt => (
                                                <Option key={opt.id} value={opt.id}>{opt.label}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Card>

                        <Card title="Edit Shipping Information" style={{ marginBottom: 16 }}>
                            <Row gutter={16}>
                                <Col xs={24} sm={12} md={6}><Form.Item name="shippingAddress1" label="Shipping Address 1" rules={[{ required: true, message: "Shipping address is required" }]}><Input /></Form.Item></Col>
                                <Col xs={24} sm={12} md={6}><Form.Item name="shippingAddress2" label="Shipping Address 2" rules={[{ required: true, message: "Shipping address is required" }]}><Input /></Form.Item></Col>
                                <Col xs={24} sm={12} md={6}><Form.Item name="shippingCity" label="Shipping City" rules={[{ required: true, message: "Shipping city is required" }]}><Input /></Form.Item></Col>
                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item name="shippingDistrict" label="Shipping District" rules={[{ required: true, message: "Shipping district is required" }]}>
                                        <Select placeholder="Select District" allowClear>
                                            {districts.map(opt => (
                                                <Option key={opt.id} value={opt.id}>{opt.label}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Card>

                        <Form.Item>
                            <Row justify="end" gutter={8}>
                                <Col>
                                    <Button type="primary" htmlType="submit" loading={loading}>Save Changes</Button>
                                </Col>
                                <Col>
                                    <Button onClick={() => navigate(`/mlm/userview/${id}`)}>Cancel</Button>
                                </Col>
                            </Row>
                        </Form.Item>
                    </Form>
                </Content>
                <Footerdiv />
            </Layout>
        </Spin>
    );
};

export default MLMUserEdit;
